import qs from 'qs';
import { message } from 'm-ui';
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

function getUrlParam(paramName: string) {
    const searchParser = new URLSearchParams(window.location.search);
    return searchParser.get(paramName);
}

let accountId = getUrlParam('__accountId__');

const defaultConfig: AxiosRequestConfig = {
    withCredentials: true,
    timeout: 10 * 60 * 1000,
    paramsSerializer(params) {
        if (typeof params.__accountId__ === 'undefined' && accountId) {
            params.__accountId__ = accountId;
        }
        return qs.stringify(params);
    },
    headers: {
        post: {
            'Content-Type': 'application/json',
        },
    },
};

function showError(msg: string, host?: string) {
    message.error(msg);
}
function getErrorInfo(error) {
    const url = error?.config?.url || '';
    const errorMessage = error?.data?.error_msg || error?.data?.message || ''; // 后端返回状态不统一，前端处理
    const host = error?.data['host-name'] || '';
    // TODO send error

    return {
        url,
        errorMessage,
        host,
    };
}
function successInterceptor(response: AxiosResponse, silent: boolean) {
    if (response?.data instanceof Blob) {
        return response?.data;
    }
    if (
        +response?.data?.result === 1 ||
        +response?.data?.status === 200 ||
        +response?.data?.result === 200
    ) {
        // 后端返回状态不统一，前端处理
        return response.data;
    }
    const { errorMessage, host } = getErrorInfo(response);
    if (!silent) {
        if (Array.isArray(response?.data?.errors)) {
            const errors = [];
            response.data.errors.forEach((error) => {
                errors.push(error.errorMessage);
            });
            showError(errors.join('<br>'), host);
        } else {
            showError(errorMessage || '接口错误，请重试', host);
        }
    }
    return Promise.reject(response);
}
function errorInterceptor(error, silent) {
    if (Axios.isCancel(error) && error.message === 'CANCELED_DUE_TO_NEW_REQUEST') {
        return Promise.reject(error);
    }
    if (!silent) {
        if (error.response && error.response.status === 500) {
            showError('系统超时，请重试');
        } else if (
            error.code === 'ECONNABORTED' ||
            (error.response && error.response.status === 408)
        ) {
            showError('连接失败，请检查您的网络状况');
        } else {
            showError('网络超时，请重试');
        }
    }
    return Promise.reject(error);
}
function requestInterceptor(config) {
    config.params = config.params || {};
    if (typeof config.params.__accountId__ === 'undefined' && accountId) {
        config.params.__accountId__ = accountId;
    }
    return config;
}

interface FactoryConfig {
    silent?: boolean;
    noInterceptor?: boolean;
}

export function HttpClient(baseUrl, config?: AxiosRequestConfig & FactoryConfig): AxiosInstance {
    const mergedConfig = Object.assign({}, defaultConfig, config || {});
    if (baseUrl) {
        mergedConfig.baseURL = baseUrl;
    }
    if (!mergedConfig.params) {
        mergedConfig.params = {};
    }
    const instance = Axios.create(mergedConfig);
    if (mergedConfig.noInterceptor) {
        return instance;
    }
    instance.interceptors.request.use(
        function (config) {
            return requestInterceptor(config);
        },
        function (error) {
            return Promise.reject(error);
        }
    );
    instance.interceptors.response.use(
        (response) => {
            return successInterceptor(response, mergedConfig.silent);
        },
        (error) => {
            return errorInterceptor(error, mergedConfig.silent);
        }
    );
    return instance;
}

const client = HttpClient('/', {
    withCredentials: true,
});

export default client;
